document.addEventListener('DOMContentLoaded', function() {
    let showMoreLink = document.getElementById('show-more-link');
    let showLessLink = document.getElementById('show-less-link');
    let shortDesc = document.getElementById('product-description-short');
    let fullDesc = document.getElementById('product-description-full');
  
    if (showMoreLink) {
      showMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        shortDesc.style.display = 'none';
        fullDesc.style.display = 'block';
      });
    }
  
    if (showLessLink) {
      showLessLink.addEventListener('click', function(e) {
        e.preventDefault();
        shortDesc.style.display = 'block';
        fullDesc.style.display = 'none';
      });
    }
  });